// extracted by mini-css-extract-plugin
export default {"productDiscount":"wyunarO","productSponsored":"MGK98Y4"};